export default "__VITE_ASSET__DI3dUlL9__"